<script lang="ts">
import { ref, computed, reactive, defineComponent, toRefs, onMounted, nextTick, watch } from "vue";
import { HttpService } from "@/core/index";
import { useRoute } from "vue-router";
export default defineComponent({
  isGlobal: true,
  name: "NoviceGuide",
  props: {
    path: {
      type: String,
      require: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    duration: {
      type: Number,
      default: 0,
    },
    positionClass: {
      type: String,
      require: true,
    },
    errorShow: {
      type: Boolean,
      default: false,
    },
    diff:{
      type:Number,
      default:26
    }
  },
  emits:["hidden"],
  setup(props, { emit }) {
    const route = useRoute();
    const state = reactive({
      isFirst: false,
      noviceTop: 0,
      noviceLeft: 0,
      show: false
    });
    const useFirstPointApi = () => {
      const api = (params) =>
        HttpService.axios({
          method: "GET",
          url: "/first/point",
          params,
        });
      return HttpService.useRequest<any>(api);
    };
    const useAddPointApi = () => {
      const api = (data) =>
        HttpService.axios({
          method: "POST",
          url: "/first/point",
          data,
        });
      return HttpService.useRequest<any>(api);
    };
    const { run, data, loading } = useFirstPointApi();
    const { run: runAdd } = useAddPointApi();
    watch(
      () => props.duration,
      (n) => {
        if (n) {
          setTimeout(() => {
            state.show = false;
            emit("hidden")
          }, n);
        }
      }
    );

    watch(
      () => props.positionClass,
      async (n) => {
        if (n) {
          const { matched } = route;
          const path = matched[matched.length - 1]["path"];
          await run({ path, type: "pc" });
          await runAdd({ type: "pc", path });
          state.isFirst = data.value?.status;
          setTimeout(() => {
            const el = document.getElementsByClassName(props.positionClass as string);
            if (el && el[0]) {
              const { x, y } = el[0].getBoundingClientRect();
              state.noviceTop = y + props.diff;
              state.noviceLeft = x;
              if (props.errorShow) {
                state.show = props.errorShow && state.isFirst;
              } else {
                state.show = state.isFirst;
              }
            }
          }, 100);
        }
      }
    );
    return {
      ...toRefs(state),
    };
  },
});
</script>
<template>
  <div
    class="ub ub-ac ub-ps ub-ver novice-div"
    :style="{ top: noviceTop + 'px', left: noviceLeft + 'px' }"
    v-if="show"
  >
    <div class="jiantou"></div>
    <div class="ub fw title">
      <slot name="title">智能引导</slot>
    </div>
    <div class="ub ub-ver fw content">
      <slot name="content">
        <div class="ub ub-ac ub-ps fw">点击这里创建项目登记信息，</div>
        <div class="ub ub-ac ub-ps fw">开启项目管理工作。</div>
      </slot>
    </div>
    <div class="ub ub-ac ub-pc btn" v-if="showButton" @click="show = false">
      <slot name="button">知道了</slot>
    </div>
  </div>
</template>
<style scoped lang="less">
.novice-div {
  min-width: 300px;
  min-height: 105px;
  background-color: rgba(46, 122, 255, 1);
  border-radius: 12px;
  color: #ffffff;
  position: fixed;
  padding: 24px;
  box-sizing: border-box;
  left: 0;
  z-index: 1000;
  .jiantou {
    position: absolute;
    top: -17px;
    left: 20px;
    width: 0;
    height: 0;
    border-width: 10px;
    border-style: solid;
    border: 10px solid rgba(46, 122, 255, 1);
    border-color: transparent transparent rgba(46, 122, 255, 1) transparent;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .content {
    font-size: 14px;
  }
  .btn {
    width: 80px;
    height: 30px;
    border-radius: 15px;
    background-color: #fff;
    color: #333;
    position: absolute;
    right: 12px;
    bottom: 12px;
    cursor: pointer;
  }
}
</style>
